import PND1KorReportComponent from "features/Report/components/SalaryGroup/PND1KorReport";
import usePND1KorReport from "features/Report/hooks/salaryGroup/usePND1KorReport";

const PND1KorReportPage = () => {
    const usePND1KorReportProps = usePND1KorReport();
    return (<PND1KorReportComponent {...usePND1KorReportProps} />)
}

export default PND1KorReportPage;